import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const domains = [
  {
    icon: 'ri-bar-chart-line',
    title: 'Conseil en gestion',
    description: "Organisation et structuration de l'activité pour une gestion optimale au quotidien.",
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Stratégie d\'entreprise',
    description: "Définition d'orientations claires pour guider les décisions et assurer la croissance.",
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Optimisation des activités',
    description: "Analyse des processus et amélioration des performances pour plus d'efficacité.",
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-[#1a2e4a] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://public.readdy.ai/ai/img_res/cb15ba19155e6fef310af8d38af0efec.jpg"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto px-6">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40 mb-4">À propos</p>
          <h1 className="text-4xl md:text-5xl font-light text-white leading-tight tracking-tight mb-6">
            Une expertise au service<br />
            <span className="font-semibold">de votre développement</span>
          </h1>
          <p className="text-sm text-white/60 max-w-xl leading-relaxed">
            BONIEK est une activité indépendante de conseil basée à Bordeaux, dédiée à l&apos;accompagnement des entrepreneurs et des entreprises.
          </p>
        </div>
      </section>

      {/* Présentation */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=confident%20professional%20businesswoman%20portrait%20in%20elegant%20modern%20office%20Bordeaux%20France%2C%20sophisticated%20dark%20navy%20blue%20suit%2C%20warm%20natural%20light%2C%20minimalist%20background%2C%20high-end%20consulting%20professional%2C%20trustworthy%20and%20competent%20expression%2C%20clean%20corporate%20photography%20style&width=700&height=600&seq=about-portrait-boniek-004&orientation=portrait"
                  alt="Dominika Julia Boniek – Conseil en gestion Bordeaux"
                  className="w-full h-[460px] object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-[#1a2e4a] rounded-lg p-5 hidden lg:block">
                <p className="text-xs text-white/50 uppercase tracking-widest mb-1">Dirigeante</p>
                <p className="text-sm font-semibold text-white">Dominika Julia Boniek</p>
              </div>
            </div>

            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-4">L&apos;entreprise</p>
              <h2 className="text-3xl font-light text-[#1a2e4a] leading-tight mb-6 tracking-tight">
                BONIEK –<br />
                <span className="font-semibold">Conseil indépendant</span>
              </h2>
              <p className="text-sm text-gray-500 leading-relaxed mb-5">
                BONIEK est une entreprise individuelle de conseil en affaires et gestion, basée à Bordeaux. Elle est dirigée par Dominika Julia Boniek, spécialisée dans le conseil en gestion et le développement d&apos;activité.
              </p>
              <p className="text-sm text-gray-500 leading-relaxed mb-8">
                L&apos;objectif est d&apos;accompagner les entrepreneurs dans leurs décisions stratégiques et d&apos;améliorer la performance de leur entreprise grâce à une approche rigoureuse et personnalisée.
              </p>

              <div className="grid grid-cols-2 gap-4 mb-8">
                {[
                  { label: 'Statut', value: 'Entrepreneur individuel' },
                  { label: 'Activité', value: '70.22Z – Conseil en gestion' },
                  { label: 'SIRET', value: '102 005 980 00010' },
                  { label: 'Localisation', value: 'Bordeaux, France' },
                ].map((info) => (
                  <div key={info.label} className="p-4 rounded-lg bg-[#f5f4f2]">
                    <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">{info.label}</p>
                    <p className="text-sm font-medium text-[#1a2e4a]">{info.value}</p>
                  </div>
                ))}
              </div>

              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-md bg-[#1a2e4a] text-white text-sm font-semibold hover:bg-[#243d61] transition-colors duration-200 cursor-pointer"
              >
                Prendre contact
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Domaines */}
      <section className="py-24 bg-[#f5f4f2]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-3">Expertise</p>
            <h2 className="text-3xl md:text-4xl font-light text-[#1a2e4a] tracking-tight">
              Domaines <span className="font-semibold">d&apos;intervention</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {domains.map((domain) => (
              <div
                key={domain.title}
                className="p-8 rounded-lg bg-white border border-gray-100 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-[#1a2e4a]/8 mb-6">
                  <i className={`${domain.icon} text-[#1a2e4a] text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-[#1a2e4a] mb-3">{domain.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{domain.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valeurs */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-4">Nos valeurs</p>
              <h2 className="text-3xl font-light text-[#1a2e4a] leading-tight mb-8 tracking-tight">
                Un engagement<br />
                <span className="font-semibold">de qualité et de rigueur</span>
              </h2>
              <div className="flex flex-col gap-6">
                {[
                  { icon: 'ri-shield-check-line', title: 'Fiabilité', desc: 'Un accompagnement sérieux et professionnel à chaque étape de votre projet.' },
                  { icon: 'ri-focus-3-line', title: 'Précision', desc: 'Des analyses approfondies pour des recommandations pertinentes et adaptées.' },
                  { icon: 'ri-user-heart-line', title: 'Proximité', desc: 'Un interlocuteur unique, disponible et à l\'écoute de vos besoins.' },
                ].map((val) => (
                  <div key={val.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-[#1a2e4a]/8 shrink-0">
                      <i className={`${val.icon} text-[#1a2e4a] text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-[#1a2e4a] mb-1">{val.title}</h4>
                      <p className="text-sm text-gray-500 leading-relaxed">{val.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20professional%20business%20meeting%20in%20modern%20Bordeaux%20office%2C%20two%20people%20discussing%20strategy%20documents%20at%20a%20clean%20minimalist%20table%2C%20dark%20navy%20blue%20and%20white%20interior%2C%20natural%20light%2C%20sophisticated%20corporate%20environment%2C%20trust%20and%20collaboration%20atmosphere&width=700&height=520&seq=about-values-boniek-005&orientation=landscape"
                alt="Valeurs BONIEK conseil Bordeaux"
                className="w-full h-[400px] object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
